module.exports = __webpack_public_path__ + "front/img/71.5ec91060.png";